import { Controller } from "stimulus";
import AF from './../helpers/AF';
import { Rect } from './../helpers/rect';

export default class extends Controller {
    static targets = [ 'inner' ];

    initialize() {
        this.handleResize = this.handleResize.bind(this);
        this.af = AF.instance();
        this.read = this.read.bind(this);
        this.write = this.write.bind(this);
    }

    connect() {
        // window.addEventListener('resize', this.handleResize);
        // this.handleResize();
        this.rect = new Rect({ el: this.element });
    }

    read() {
        this.rect.tick();
    }

    write() {
       for (let i = this.children.length - 1; i >= 0; i--) {
            this.children[i].animate(this.rect.progress);
        }
    }
    
    handleResize() {
        const rect = this.innerTarget.getBoundingClientRect();
        this.height = rect.height;
        this.element.style.height = this.height + 'px';
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/footer_controller.js